import type { RouteObject } from 'react-router-dom'

import { AuthProvider } from '@/contexts'
import { LoginPage } from '@/features/auth'
import { AuthLayout } from '@/layouts'

export const authRoutes: RouteObject = {
  path: '/login',
  element: (
    <AuthProvider>
      <AuthLayout />
    </AuthProvider>
  ),
  children: [
    {
      path: '',
      element: <LoginPage />
    }
  ]
}
